import React from "react";
import { formatINR } from "../data/dummyLedgerTransactionsData";
import { FaArrowLeft } from "react-icons/fa";
import SearchableSelect from "../../../Component/SearchableSelect/SearchableSelect";

export default function LedgerTransactionFilters({
  accounts = [],
  selectedAccountId = "",
  onChangeAccount,
  selectedMonth = "",
  onChangeMonth,
  group = "General",
  type = "Asset",
  openingBalance = 0,
  openingType = "Dr",
  onShowTransactions,
  onBack,
}) {
  const isOpCr = openingType === "Cr";

  return (
    <div className="lt_filter_bar">
      {/* Ledger Account Select */}
      <div className="lt_filter_group">
        <label className="lt_filter_label">Ledger Account:</label>
        <SearchableSelect
          options={accounts}
          value={selectedAccountId}
          onChange={(val) => onChangeAccount(val)}
          placeholder="-- Type to search ledger --"
          height="28px"
          minWidth="260px"
          isClearable={false}
        />
      </div>

      {/* Month Selector */}
      <div className="lt_filter_group">
        <label className="lt_filter_label">Month:</label>
        <input
          type="month"
          className="filter-input"
          value={selectedMonth}
          onChange={(e) => onChangeMonth(e.target.value)}
          style={{ width: 130 }}
        />
      </div>

      {/* Account Info Pill Box */}
      <div className="lt_info_pill_box">
        <div className="lt_info_pill">
          <span className="lt_pill_label">Group:</span>
          <span className="lt_pill_value">{group}</span>
        </div>
        <div className="lt_pill_sep"></div>
        <div className="lt_info_pill">
          <span className="lt_pill_label">Type:</span>
          <span className="lt_pill_value">{type}</span>
        </div>
        <div className="lt_pill_sep"></div>
        <div className="lt_info_pill">
          <span className="lt_pill_label">Opening Balance:</span>
          <span className="lt_pill_value">
            ₹ {formatINR(openingBalance)}
          </span>
          <span className={isOpCr ? "drcr_text_cr" : "drcr_text_dr"}>
            {" "}{openingType}
          </span>
        </div>
      </div>

      {/* Filter Buttons */}
      <div className="lt_filter_buttons">
        <button
          type="button"
          className="lt_btn_apply"
          onClick={onShowTransactions}
        >
          Show Transactions
        </button>
        <button
          type="button"
          className="lt_btn_back"
          onClick={onBack}
          title="Back to Monthly Ledger Summary"
        >
          <FaArrowLeft style={{ fontSize: "10px" }} />
          Back
        </button>
      </div>
    </div>
  );
}
